import { FC } from 'react';

export const AppNotReady: FC = () => (
  <div className="spinner-block">
    <i className="fa fa-spinner fa-spin fa-5x"></i>
  </div>
);
